import { apiGet } from '../../../../../generic/Api_Functions'

export const changeDialogInfo = async (statusChangeDialogInfo) => {
  let node = statusChangeDialogInfo?.node
  let jobReference = statusChangeDialogInfo?.jobReference
  let fabricationOrderInfo = statusChangeDialogInfo?.fabricationOrder

  let workflowId = null
  try {
    if (fabricationOrderInfo.id) {
      const response = await apiGet(`workflowIdByFabricationOrder/${fabricationOrderInfo.id}`)
      workflowId = response.result
    }

    if (workflowId) {
      const resources = await apiGet(`getResourcesByWorkflowId/${workflowId}`)
      const workflowNodes = resources?.nodes || []
      const jobReferenceId = jobReference?.id
      const nodeId = node?.id

      const matchNode = workflowNodes.find((currentNode) => {
        if (jobReferenceId) return currentNode?.jobReference?.id === jobReferenceId
        if (nodeId) return currentNode?.id === nodeId
        return false
      })

      if (matchNode?.jobReference) {
        // S242 (ENMIENDA 07, G3-11 c) -- `getResourcesByWorkflowId` habla el contrato del EDITOR DE
        // WORKFLOW: desde sun #3612 el identificador de negocio vive en `code` y `name` queda como el
        // campo de texto libre, que nadie rellena. Todos los lectores de MOS del nodo seleccionado
        // leen `node.name` -- el título del puesto, `currentNodeName` del provider, las descripciones
        // de job, la barra de inspección y el widget de incidencias -- y eso es lo que les da el
        // endpoint de contexto activo. Sin esta normalización, todos ellos quedaban VACÍOS desde que
        // se arrancaba un job hasta recargar la página, que es el defecto que el PO vio al iniciar en
        // lote. Se normaliza aquí, el ÚNICO punto donde se cruzan los dos contratos, y nunca se pisa
        // un nombre que el editor sí traiga.
        node = { ...matchNode, name: matchNode.name || matchNode.code }
        jobReference = matchNode.jobReference
      } else {
        // S243 (ENMIENDA 08, G3-12 a) -- EL CAMINO DE RESPALDO. Sin coincidencia, la selección se queda
        // con el nodo de la FILA DE LA COLA, y esa fila no publica `workflow` en ninguna parte (JSON
        // real de `contrato-sun.md` §3.1): el widget de operación caía al guion hasta recargar, que es
        // el defecto que el PO vio al iniciar un solo job. El dato ya viaja aquí mismo: CADA nodo de
        // esta respuesta publica su `workflow` con identificador y código, y TODOS son del mismo
        // workflow -- por eso vale cualquiera de ellos y no hace falta ni una petición más.
        // ⚠️ Lo que ese `workflow.name` lleva es el CÓDIGO del workflow (`IdName.createIdName(id,
        // getCode())`), no el texto libre del editor: es el MISMO valor que el contexto activo publica
        // tras recargar (sun `40db85e51f`), y por eso el dato deja de depender de si se recargó.
        const workflowOfResponse = workflowNodes.find((currentNode) => currentNode?.workflow?.name)?.workflow
        if (workflowOfResponse && !node?.workflow) {
          node = { ...node, workflow: workflowOfResponse }
        }
      }

      if (!fabricationOrderInfo?.workflow) {
        fabricationOrderInfo = { ...fabricationOrderInfo, workflow: { id: workflowId } }
      }
    }
  } catch (error) {
    console.error('Error changing dialog info:', error)
  }

  return { node, fabricationOrderInfo, jobReference }
}
